export class UserSessionData {
  currentUser: any = {};
  roleTypeId: number = 0;
  ipAddress: string = '';
}
